import s from "@rei/simple-top-categories";
import { resolveComponent as c, openBlock as l, createElementBlock as d, normalizeClass as g, normalizeStyle as u, createVNode as f, createCommentVNode as m } from "vue";
const _ = (a, t) => {
  const e = a.__vccOpts || a;
  for (const [r, o] of t)
    e[r] = o;
  return e;
}, p = {
  name: "BrandRail",
  components: {
    SimpleTopCategories: s
  },
  props: {
    categories: {
      type: Array,
      required: !0,
      default: () => []
    },
    mediaConfig: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    categoriesConfig: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    grid: {
      type: String,
      required: !1,
      default: "5"
    },
    cta: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    body: {
      type: String,
      required: !1,
      default: ""
    },
    footerAlignment: {
      type: String,
      required: !1,
      default: ""
    },
    imageRatio: {
      type: Object,
      required: !1,
      default: () => {
      }
    }
  },
  computed: {
    cssVars() {
      return {
        "--grid-columns": this.grid
      };
    },
    wrapperClasses() {
      var t;
      return ["brand-rail", (t = this.categoriesConfig) != null && t.hasBackground ? "brand-rail--has-background" : ""];
    }
  }
};
function y(a, t, e, r, o, i) {
  const n = c("simple-top-categories");
  return e.categories.length ? (l(), d("div", {
    key: 0,
    class: g(i.wrapperClasses),
    style: u(i.cssVars)
  }, [f(n, {
    categories: e.categories,
    "media-config": e.mediaConfig,
    cta: e.cta,
    body: e.body,
    "footer-alignment": e.footerAlignment,
    "image-ratio": e.imageRatio
  }, null, 8, ["categories", "media-config", "cta", "body", "footer-alignment", "image-ratio"])], 6)) : m("", !0);
}
const h = /* @__PURE__ */ _(p, [["render", y]]);
export {
  h as default
};
